import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import es from './locales/es.json'
import fr from './locales/fr.json'
import ja from './locales/ja.json'
import pt from './locales/pt.json'
import zh from './locales/zh.json'

export const SUPPORTED_LANGS = ['en', 'ja', 'es', 'fr', 'pt', 'zh'] as const
export type SupportedLang = (typeof SUPPORTED_LANGS)[number]
export const DEFAULT_LANG: SupportedLang = 'en'
export const LANG_STORAGE_KEY = 'goaltree_lang'

function detectLang(): SupportedLang {
  // 1. ?lang= query param — handoff from www (e.g. goaltree.ai/ja → app?lang=ja)
  const params = new URLSearchParams(window.location.search)
  const paramLang = params.get('lang')
  if (paramLang && (SUPPORTED_LANGS as readonly string[]).includes(paramLang)) {
    localStorage.setItem(LANG_STORAGE_KEY, paramLang)
    params.delete('lang')
    const qs = params.toString()
    window.history.replaceState(
      {},
      '',
      window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash,
    )
    return paramLang as SupportedLang
  }

  // 2. Persisted preference
  const stored = localStorage.getItem(LANG_STORAGE_KEY)
  if (stored && (SUPPORTED_LANGS as readonly string[]).includes(stored)) {
    return stored as SupportedLang
  }

  return DEFAULT_LANG
}

const detectedLang = detectLang()

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ja: { translation: ja },
    es: { translation: es },
    pt: { translation: pt },
    fr: { translation: fr },
    zh: { translation: zh },
  },
  lng: detectedLang,
  fallbackLng: DEFAULT_LANG,
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
